import React, { useState, useEffect } from 'react';
import { Modal, Form, Input, Row, Col, Select, Switch } from 'antd';
import useApi from '../../hooks/useApi';

const ModalEdit = ({ visible, id, onCancel, onSuccess, initialData }) => {
  const [form] = Form.useForm();
  const [categorias, setCategorias] = useState([]);
  
  const { callApi: editDepartamento } = useApi(`https://vision.alfama.com/api/update/departamentos/${id}`, {
    method: 'PUT',
    includeToken: true,
    successMessage: 'Departamento atualizado com sucesso!',
    errorMessage: 'Erro ao atualizar departamento'
  });
  
  const { callApi: viewCategorias } = useApi('https://vision.alfama.com/api/view/categorias', { 
    includeToken: true,
  });
  
  useEffect(() => {
    const fetchCategorias = async () => {
      try {
        const response = await viewCategorias();
        if (response && Array.isArray(response)) {
          const formattedCategorias = response.map(categoria => ({
            value: categoria.id,
            label: categoria.nome
          }));
          setCategorias(formattedCategorias);
        }
      } catch (error) {
        console.error('Erro ao buscar categorias:', error);
      }
    };
    
    fetchCategorias();
  }, []);

  useEffect(() => {
    // Atualiza o form quando initialData mudar
    if (initialData) {
      form.setFieldsValue({
        nome: initialData.nome,
        categoria: initialData.categoria_id, // Usa categoria_id ao invés de categoria
        situacao: initialData.status === 'ativo',
      });
    }
  }, [initialData, form]);
  
  const handleConfirm = async () => {
    try {
      const values = await form.validateFields();
      
      // Prepara os dados para envio
      const dataToSend = {
        ...values,
        categoria_id: values.categoria,
        situacao: values.situacao ? 1 : 0
      };
      
      await editDepartamento(dataToSend);
      form.resetFields();
      onCancel();
      onSuccess();
    } catch (error) {
      if (error.errorFields) {
        return;
      }
      console.error('Erro ao editar departamento:', error);
    }
  };
  
  return (
    <Modal
      title={`Editar Departamento - ID: ${id}`}
      open={visible}
      onCancel={() => {
        form.resetFields();
        onCancel();
      }}
      onOk={handleConfirm}
      okText="Salvar"
      cancelText="Cancelar"
    >
      <Form
        form={form}
        layout="vertical"
      >
        <Row gutter={16}>
          <Col span={10}>
            <Form.Item
              name="nome"
              label="Nome"
              rules={[{ required: true, message: 'Por favor, insira o nome do departamento' }]}
            >
              <Input />
            </Form.Item>
          </Col>
          <Col span={8}>
            <Form.Item
              name="categoria"
              label="Categoria"
              rules={[{ required: true, message: 'Por favor, selecione uma categoria' }]}
            >
              <Select
                placeholder="Selecione uma categoria"
                options={categorias}
                loading={categorias.length === 0}
              />
            </Form.Item>
          </Col>
          <Col span={6}>
            <Form.Item
              name="situacao"
              label="Situação"
              valuePropName="checked"
            >
              <Switch
                checkedChildren="Ativo" 
                unCheckedChildren="Bloqueado"
              />
            </Form.Item>
          </Col>
        </Row>
      </Form>
    </Modal>
  );
};

export default ModalEdit;